import { useQuery } from "@tanstack/react-query";
import { getGeographies } from "api/account";


export const useGeogeaphies = () => {
	return useQuery({
        queryKey: ['geographies'],
		queryFn: getGeographies,
	});
};